import { initCounters } from './modules/counterAnimator.js';

document.addEventListener('DOMContentLoaded', () => {
    initCounters({ duration: 2000 });
});